export const VARIANTS = {
  SINGLE_LEVEL: 'singleLevel',
  MULTI_LEVEL: 'multiLevel',
};

export const MULTI_VARIANT_LEVELS = {
  FIRST: 'first',
  SECOND: 'second',
};
